module.exports = __webpack_public_path__ + "img/41_28.2e6aebc1.png";